export const isMaliciousUrl = (url: string) => url.toLowerCase().trim().startsWith('data:');
